import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useOpenableControls } from '../../../../generic-hooks'
import { NOW_LABEL } from '../../../../now'
import { ProductSearchFlag } from '../../ProductSearchFlag'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'
import { ProductSearchResultItemNowDialog } from '../ProductSearchResultItemNowDialog'

export const ProductSearchResultItemNowLabel: FC = () => {
  const modalControls = useOpenableControls()
  const { nowDetails } = useProductSearchResultItemContext()

  return (
    <>
      <ProductSearchFlag
        className="border-light-primary-strong bg-light-brand-medium capitalize"
        data-qa-id="form-now-modal-button"
        onClick={modalControls.handleOpen}
        slots={{
          root: 'button',
        }}
        type="button"
      >
        {nowDetails.nowCustomerJourneyEnabled ? (
          <FormattedMessage id="product.label.nowProductGroup" />
        ) : (
          NOW_LABEL
        )}
      </ProductSearchFlag>
      <ProductSearchResultItemNowDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
